__turbopack_context__.v({
  "className": "source_sans_3_25df1729-module__aUXieq__className",
  "variable": "source_sans_3_25df1729-module__aUXieq__variable",
});
